/* One view of HydroHub for the proposal's frames: the real components with the example dataset, in the portal's
   shell, laid out for the Stage's mode. Keys match the proposal data: oversikt · kraftverk · kraftverk_detalj ·
   hendelser · rapporter · service · spor (the overview with «Spør HydroHub» open) · ai (the workspace). */
import { Shell } from "./Shell";
import { Hendelser, Kraftverk, KraftverkDetalj, Oversikt } from "./views";
import { Ai, Rapporter, Service, Spor, sporOverlay } from "./views2";

const VIEWS = {
  oversikt: { nav: "oversikt", C: Oversikt },
  kraftverk: { nav: "kraftverk", C: Kraftverk },
  kraftverk_detalj: { nav: "kraftverk", C: KraftverkDetalj },
  hendelser: { nav: "hendelser", C: Hendelser },
  rapporter: { nav: "rapporter", C: Rapporter },
  service: { nav: "service", C: Service },
  spor: { nav: "oversikt", C: Spor, overlay: sporOverlay },
  ai: { nav: "ai", C: Ai, bare: true },
};

export const HhView = ({ k = "oversikt", mode = "full" }) => {
  const v = VIEWS[k] || VIEWS.oversikt;
  const C = v.C;
  return (
    <Shell mode={mode} active={v.nav} overlay={v.overlay ? v.overlay(mode) : null} bare={v.bare}>
      <C mode={mode} />
    </Shell>
  );
};

export const HH_VIEW_KEYS = Object.keys(VIEWS);
